export default "__VITE_ASSET__DDRikVQ5__"